module.exports = {"title":"Delete ticket","description":"Are you sure you want to delete that ticket?","yes":"Yes","no":"No"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/AlertModalBoca/locales/fr.json
// module id = 1199
// module chunks = 0